import type { EventInfo } from '@ps/isp-web-services-types';
import produce from 'immer';

import { defaultState } from './defaultState';

type State = typeof defaultState;

export const reducers = {
  eventInfoRequested: (state: State): State => ({
    ...state,
    isLoading: true
  }),
  clearEventInfo: (state: State): State => ({
    ...state,
    eventInfo: undefined
  }),
  clear: (): State => produce(defaultState, (draft) => draft),
  dataLoadSuccess: (state: State, payload: EventInfo): State => ({
    ...state,
    eventInfo: payload,
    errorCode: undefined
  }),
  dataLoadFailed: (state: State, payload: string): State => ({
    ...state,
    errorCode: payload
  }),
  preloaded: (state: State): State => ({
    ...state,
    isLoading: false,
    hasPreloaded: true
  }),
  setHasTeamStats: (state: State, payload: boolean): State => ({
    ...state,
    hasTeamStats: payload
  })
};
